import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchReviewQueue } from '../api/review.api';
import { queryKeys } from '@/shared/lib/queryKeys';
import type { ReviewQueueItem } from '@/shared/types/domain';

/**
 * A fila (US-18).
 *
 * `enabled` é decisão de quem chama, de propósito: `/analise` não dispara a
 * consulta para quem não tem `reviewProject` (spec §6.3 — "a página não
 * dispara a consulta"), e a sidebar dispara sempre que a capacidade existir,
 * para calcular o contador. As duas decisões vivem em cada chamador, não
 * aqui — um `enabled` fixo aqui obrigaria um dos dois a se contorcer.
 */
export function useReviewQueue(enabled = true): UseQueryResult<ReviewQueueItem[]> {
  return useQuery({
    queryKey: queryKeys.reviewQueue,
    queryFn: fetchReviewQueue,
    enabled,
    staleTime: 30_000,
  });
}
